function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M375.786,368.016c-1.022,62.699-34.434,85.385-69.898,83.283c-35.465-2.093-60.132-18.537-85.32-18.537l-1.032,0.576 c-25.188,0-49.854,17.021-85.319,19.114c-35.466,2.093-68.876-19.449-69.898-82.148c2.056-57.565,45.911-61.798,83.265-129.8 c32.891-59.881,71.954-55.035,71.954-55.035h1.03c0,0,39.4-4.586,71.955,55.035C329.698,308.599,373.73,310.449,375.786,368.016z  M156.203,159.636c31.413-2.382,54.172-40.021,50.832-84.071c-3.34-44.049-31.514-77.828-62.927-75.446 C112.695,2.501,89.936,40.141,93.276,84.19C96.616,128.239,124.789,162.018,156.203,159.636z M275.264,160.401 c30.698,8.368,65.097-19.742,76.83-62.786c11.732-43.044-3.642-84.722-34.339-93.09c-30.698-8.368-65.097,19.742-76.829,62.786 C229.193,110.354,244.566,152.033,275.264,160.401z M417.486,125.937c-26.732-7.288-56.688,17.19-66.905,54.674 c-10.217,37.484,3.171,73.777,29.903,81.064c26.733,7.287,56.688-17.191,66.906-54.675 C457.608,169.518,444.22,133.224,417.486,125.937z M102.008,180.608c-10.218-37.482-40.172-61.961-66.905-54.674 s-40.122,43.581-29.904,81.064c10.218,37.482,40.173,61.961,66.906,54.674C98.837,254.386,112.225,218.092,102.008,180.608z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function SvgPawBlackShape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "80px",
    height: "80px",
    viewBox: "0 0 452.589 452.59",
    style: {
      enableBackground: "new 0 0 452.589 452.59"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPawBlackShape);
export default __webpack_public_path__ + "static/media/paw-black-shape.0922a803.svg";
export { ForwardRef as ReactComponent };